import { cross, thanksPopUpTick } from "../../../../assets/assetsSVG";
import QuestLabs from "../../../../components/QuestLabs";
import { ThankYouPopupProps } from "../types/SurveyTypes";

const ThankYouPopup: React.FC<ThankYouPopupProps> = ({
  handleThanks,
  showFooter,
  iconColor,
  themeManager,
}) => {
  return (
    <div>
      <div
        className="q_submit_cross_icon"
        onClick={handleThanks}
        style={{ cursor: "pointer" }}
      >
        {cross(iconColor)}
      </div>
      <div className="q-fw-thanks">
        <div>
          <div className="q-svg-thanks">{thanksPopUpTick(themeManager.getThanksPopUbIconBackgroundStyle())}</div>
          <div className="q_fw_submit_box">
            <div className="q_feedback_text_submitted">
              <div
                className="q_feedback_text_cont"
                style={themeManager.getHeaderStyles().heading}
              >
                Feedback Submitted
              </div>
              <div
                className="q_fw_submit_desc"
                style={themeManager.getHeaderStyles().description}
              >
                Thanks for submitting your feedback with us. We appreciate your
                review and will assure you to surely consider them.
              </div>
            </div>
            <div
              onClick={() => handleThanks()}
              className="q_fw_submit_back"
              style={themeManager.getButtonStyles().secondary}
            >
              Go to home!
            </div>
          </div>
        </div>
      </div>
      {showFooter && <QuestLabs style={themeManager.getFooterStyles()} />}
    </div>
  );
};

export default ThankYouPopup;
